/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateLaborActivityRequest } from '../../models/create-labor-activity-request';
import { LaborActivityDto } from '../../models/labor-activity-dto';

export interface CreateLaborActivity$Params {
      body: CreateLaborActivityRequest
}

export function createLaborActivity(http: HttpClient, rootUrl: string, params: CreateLaborActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDto>> {
  const rb = new RequestBuilder(rootUrl, createLaborActivity.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborActivityDto>;
    })
  );
}

createLaborActivity.PATH = '/v0/laborActivities/{id}';
